import FetchMoreWrapper from 'js/components/FetchMoreWrapper'

import { WIKI_LIST } from './WikiList.queries'

const WikiList = (props) => {
    return <FetchMoreWrapper query={WIKI_LIST} {...props} />
}

export default WikiList
